<template>
  <div>
    <div class="text-muted small mt-2">
      {{ trans("admin.cdr.subExaminationImpact.overviewHeading") }}
    </div>
    <p v-if="delta.length === 0" class="mb-0">
      {{ emptyDisplay }}
    </p>
    <ul v-else class="mb-0">
      <li v-for="entry in delta" :key="entry.key">
        {{ entry.display }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    delta: { type: Array, required: true },
    emptyDisplay: { type: String, required: true },
  },
};
</script>
